export const CREATE_ROSTER = 'CREATE_ROSTER'
export const CREATE_ROSTER_SUCCESS = 'CREATE_ROSTER_SUCCESS'
export const CREATE_ROSTER_ERROR = 'CREATE_ROSTER_ERROR'

export const UPDATE_ROSTER = 'UPDATE_ROSTER'
export const UPDATE_ROSTER_SUCCESS = 'UPDATE_ROSTER_SUCCESS'
export const UPDATE_ROSTER_ERROR = 'UPDATE_ROSTER_ERROR'

export const PUBLISH_ROSTER = 'PUBLISH_ROSTER'
export const PUBLISH_ROSTER_SUCCESS = 'PUBLISH_ROSTER_SUCCESS'

export const UNPUBLISH_ROSTER = 'UNPUBLISH_ROSTER'
export const UNPUBLISH_ROSTER_SUCCESS = 'UNPUBLISH_ROSTER_SUCCESS'

export const CLEAR_ROSTER_BY_ID = 'CLEAR_ROSTER_BY_ID'
export const GET_ROSTER_BY_ID = 'GET_ROSTER_BY_ID'
export const GET_ROSTER_BY_ID_SUCCESS = 'GET_ROSTER_BY_ID_SUCCESS'
export const GET_ROSTER_BY_ID_ERROR = 'GET_ROSTER_BY_ID_ERROR'

export const CLEAR_ROSTERS_BY_CITY_PLAN_ID = 'CLEAR_ROSTERS_BY_CITY_PLAN_ID'

export const GET_ROSTERS_BY_CITY_ID = 'GET_ROSTERS_BY_CITY_ID'
export const GET_ROSTERS_BY_CITY_ID_SUCCESS = 'GET_ROSTERS_BY_CITY_ID_SUCCESS'
export const CLEAR_ROSTERS_BY_CITY_ID = 'CLEAR_ROSTERS_BY_CITY_ID'

export const SET_ROSTERS_BY_CITY_PLAN_ID_STATUS_FILTER =
  'SET_ROSTERS_BY_CITY_PLAN_ID_STATUS_FILTER'

export const DELETE_ROSTER_BY_ID = 'DELETE_ROSTER_BY_ID'
export const DELETE_ROSTER_BY_ID_SUCCESS = 'DELETE_ROSTER_BY_ID_SUCCESS'
export const DELETE_ROSTER_BY_ID_ERROR = 'DELETE_ROSTER_BY_ID_ERROR'

export const UPDATE_ROSTERS_MISSION = 'UPDATE_ROSTERS_MISSION'
export const UPDATE_ROSTERS_MISSION_SUCCESS = 'UPDATE_ROSTERS_MISSION_SUCCESS'

export const GET_CLIENT_ROSTERS_BY_CITIES = 'GET_CLIENT_ROSTERS_BY_CITIES'
export const GET_CLIENT_ROSTERS_BY_CITIES_SUCCESS =
  'GET_CLIENT_ROSTERS_BY_CITIES_SUCCESS'
